import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";
import { roleAllowed } from "@/lib/constants";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=auth

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: if returning from OAuth callback, AuthCallback exchanges session_id first
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    checkAuth();
  }, [checkAuth]);

  const loginWith = (data) => {
    if (data.token) localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };
  const can = (...roles) => user && roleAllowed(user.role, roles);

  return <AuthCtx.Provider value={{ user, loginWith, logout, can, refresh: checkAuth }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
